<template>
    <section class="ifr__warning ifr__warnings--intro">
        <div class="-ui-container">
            <div class="-ui-grid">
                <div class="-ui-col-40">
                    <h3 v-html="$t('warnings.intro.h3')"></h3>
                    <h1 v-html="$t('warnings.intro.h1')"></h1>
                    <h2 v-html="$t('warnings.intro.h2')"></h2>
                    <p v-html="$t('warnings.intro.p')"></p>
                    <div class="ifr__intro-btn">
                        <button class="ifr__question-btn" @click="startTest()">
                            <span>{{ $t('warnings.intro.btn') }}</span>
                            <span>{{ $t('warnings.intro.btn') }}</span>
                        </button>
                    </div>
                </div>
                <div class="-ui-col-60">
                    <div class="img__wrap">
                        <img src="../assets/img/warnings-intro.jpg" :alt="$t('warnings.intro.h1')">
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
export default {
    name: 'warnings-intro',
    methods: {
        startTest() {
            fullpage_api.moveTo(2)
        }
    }
}
</script>

